import { render, staticRenderFns } from "./AssignUserConfirmDialog.vue?vue&type=template&id=40546a57"
import script from "./AssignUserConfirmDialog.js?vue&type=script&lang=js&external"
export * from "./AssignUserConfirmDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports